import React from "react";
import { Radio, StatusBadge } from "../../ui";
import { batchFacts, isFull, seatsLabel } from "./addToBatch";

/**
 * BatchOptionList — the batches of one course as a pick-one list of cards:
 * name and status, then when and where it runs, then its seats.
 *
 * A full batch stays in the list, disabled and saying "Full", rather than
 * disappearing — an admin looking for "Java B2" should learn why they cannot
 * pick it, not wonder where it went.
 *
 * Props:
 *   batches    — `options` batches ({ _id, name, status, seats, … })
 *   value      — the chosen batch id
 *   onChange   — (batchId) => void
 *   showBranch — name the branch on each card (multi-branch institutes)
 */
const BatchOptionList = ({ batches, value, onChange, showBranch = false }) => (
  // A phone scrolls the whole dialog; a nested scroller there clips cards.
  <div className="tw-grid tw-gap-2 sm:tw-max-h-72 sm:tw-overflow-y-auto sm:tw-pr-1">
    {batches.map((batch) => {
      const full = isFull(batch.seats);
      const facts = batchFacts(batch, { showBranch });
      return (
        <Radio
          key={batch._id}
          variant="card"
          name="add-to-batch-target"
          value={batch._id}
          checked={value === batch._id}
          disabled={full}
          onChange={() => onChange(batch._id)}
          label={(
            <span className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
              <span className="tw-font-semibold">{batch.name}</span>
              <StatusBadge domain="batch" status={batch.status} />
            </span>
          )}
          description={(
            <>
              {facts && <span className="tw-block">{facts}</span>}
              <span className="tw-block tw-font-medium tw-text-content-muted">{seatsLabel(batch.seats)}</span>
            </>
          )}
        />
      );
    })}
  </div>
);

export default BatchOptionList;
